// Important: no !important in css
const theme = {
  matchflix: {
    name: 'Match-flix',
    login: {
      typography: {
        useNextVariants: true
      },
      palette: {
        type: 'dark',
        primary: {
          main: '#0079b0',
          light: '#74c3e6',
          contrastText: '#b3b3b3'
        }
      }
    },
    app: {
      typography: {
        useNextVariants: true
      },
      palette: {
        primary: {
          main: '#39a9dc',
          light: '#74c3e6',
          veryLight: '#74c3e6',
          contrastText: '#fff'
        },
        secondary: { main: '#00a69f' }
      },
      overrides: {
        MuiTooltip: {
          // Name of the rule
          tooltip: {
            // Some CSS

            'font-size': '16px'
          }
        }
      },
      status: {
        danger: 'orange'
      }
    },
    logo: '/img/logo_header3.png',
    loginLogo: '/img/mf_logo.png',
    loginBackground: {
      background: '#485258'
    },
    loginPaper: {
      background: '#000'
    },
    appBar: {
      background: '#39a9dc',
      zIndex: '1100',
      candidates: {
        background: '#a7111b'
      },
      companies: {
        background: 'rgba(109,120,126,0.6)'
      },
      projects: {
        background: 'rgba(109,120,126,0.2)'
      }
    }
  },
  senator: {
    name: 'Senator-Partners',
    login: {
      typography: {
        useNextVariants: true
      },
      palette: {
        primary: {
          main: '#0079b0',
          light: '#0079b0',
          contrastText: '#666'
        }
      }
    },
    app: {
      typography: {
        useNextVariants: true
      },
      palette: {
        primary: {
          main: '#587daf',
          light: '#89a3c6',
          veryLight: '#bdd2ef',
          contrastText: '#4b575f'
        },
        secondary: { main: '#00a69f' }
      },
      overrides: {
        MuiTooltip: {
          // Name of the rule
          tooltip: {
            // Some CSS

            'font-size': '16px'
          }
        }
      },
      status: {
        danger: 'orange'
      }
    },
    logo: '/img/senator_logo.png',
    loginLogo: '/img/senator_logo.png',
    loginBackground: {
      background: '#747e86'
    },
    loginPaper: {
      background: '#fff'
    },
    appBar: {
      background: '#fff',
      zIndex: '1100',

      candidates: {
        background: 'rgba(88,125,175,0.4)'
      },
      companies: {
        background: 'rgba(136,179,175,0.4)'
      },
      projects: {
        background: 'rgba(197,197,184,0.4)'
      }
    }
  },
  personaltotal: {
    name: 'Personal-Total',
    login: {
      typography: {
        useNextVariants: true
      },
      palette: {
        type: 'dark',
        primary: {
          main: '#962225',
          light: '#fff',
          contrastText: '#fff'
        }
      }
    },
    app: {
      typography: {
        useNextVariants: true
      },
      palette: {
        primary: {
          main: '#962225',
          light: '#b46365',
          veryLight: '#e89698',
          contrastText: '#fff'
        },
        secondary: { main: '#00a69f' }
      },
      overrides: {
        MuiTooltip: {
          // Name of the rule
          tooltip: {
            // Some CSS
            'font-size': '16px'
          }
        }
      },
      status: {
        danger: 'orange'
      }
    },
    logo: '/img/pt_logo.png',
    loginLogo: '/img/pt_logo.png',
    loginBackground: {
      background: '#5f6467'
    },
    appBar: {
      background: 'rgba(103,19,20,1)',
      zIndex: '1100',

      candidates: {
        background: '#a7111b'
      },
      companies: {
        background: 'rgba(109,120,126,0.6)'
      },
      projects: {
        background: '#1a171b'
      }
    },
    loginPaper: {
      background: '#962225'
    }
  },
  lienert: {
    name: 'Jörg Lienert AG',
    login: {
      typography: {
        useNextVariants: true
      },
      palette: {
        type: 'dark',
        primary: {
          main: '#962225',
          light: '#fff',
          contrastText: '#fff'
        }
      }
    },
    app: {
      typography: {
        useNextVariants: true
      },
      palette: {
        primary: {
          main: '#092455',
          light: '#697a97',
          veryLight: '#aec3e8',
          contrastText: '#fff'
        },
        secondary: { main: '#697a97' }
      },
      overrides: {
        MuiTooltip: {
          // Name of the rule
          tooltip: {
            // Some CSS
            'font-size': '16px'
          }
        }
      },
      status: {
        danger: 'orange'
      }
    },
    logo: '/img/lienert_logo.png',
    loginLogo: '/img/lienert_logo.png',
    loginBackground: {
      background: '#dcdcdc'
    },
    appBar: {
      zIndex: '1100',

      background: '#092455',
      candidates: {
        background: '#092455'
      },
      companies: {
        background: '#092455'
      },
      projects: {
        background: '#092455'
      }
    },
    loginPaper: {
      background: '#092455'
    }
  }
};
module.exports = theme;
